module.exports = __webpack_public_path__ + "static/media/advertencia.1fae686e.svg";